const getCurrency = (country) => {
  return country == 'PY' ? '₲' : '$'
}

export default getCurrency